// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__XDjQl","right":"styles_right__2ZeiZ"};